import { CartesianGrid, Line, LineChart, XAxis, YAxis } from 'recharts'
import {
  ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from '@/components/ui/chart'
import { usePageInfo } from 'app/frontend/base/config/queries'
import Card from 'app/frontend/base/components/Card'

type Props = {
  config: ChartConfig
  values: { label: string; total: number }[]
}

const AuditGraph = ({ config, values }: Props) => {
  const {
    data: { currentSeason },
  } = usePageInfo()

  return (
    <Card className='mt-2'>
      <p className='text-sm text-muted-foreground font-medium text-center mb-4'>
        Weekly keystone dungeons completed in {currentSeason?.name}
      </p>

      <ChartContainer config={config} className='max-h-[400px] w-full'>
        <LineChart
          accessibilityLayer
          data={values}
          margin={{ right: 12, bottom: 20 }}
        >
          <CartesianGrid vertical={false} />
          <XAxis
            dataKey='label'
            tickLine={false}
            axisLine={false}
            tickMargin={8}
            label={{
              value: 'Week in season',
              position: 'insideBottom',
              offset: -20,
            }}
          />
          <ChartTooltip content={<ChartTooltipContent hideLabel />} />
          <YAxis
            dataKey='total'
            tickLine={false}
            axisLine={false}
            tickMargin={8}
            width={30}
          />
          <Line
            dataKey='total'
            type='linear'
            stroke='var(--color-total)'
            strokeWidth={2}
            dot={false}
            animationDuration={750}
          />
        </LineChart>
      </ChartContainer>
    </Card>
  )
}

export default AuditGraph
